import { api } from '@/services/api/apiClient';
import type {
  AvailabilityResponse,
  BookingRequest,
  BookingResponse,
  BookingListResponse,
  BookingDetail,
} from '../types/booking.types';

function authHeaders(apiToken: string) {
  return { headers: { Authorization: `Bearer ${apiToken}` } };
}

/**
 * Get available meeting slots for the next N working days.
 */
export async function getAvailability(
  apiToken: string
): Promise<AvailabilityResponse> {
  const response = await api.get<AvailabilityResponse>(
    '/readiness/bookings/availability',
    authHeaders(apiToken)
  );
  return response.data;
}

/**
 * Create a booking — creates a Teams meeting and returns confirmation.
 */
export async function createBooking(
  request: BookingRequest,
  apiToken: string
): Promise<BookingResponse> {
  const response = await api.post<BookingResponse>(
    '/readiness/bookings',
    request,
    authHeaders(apiToken)
  );
  return response.data;
}

/**
 * List all bookings for the caller's tenant.
 */
export async function listBookings(
  apiToken: string
): Promise<BookingListResponse> {
  const response = await api.get<BookingListResponse>(
    '/readiness/bookings',
    authHeaders(apiToken)
  );
  return response.data;
}

/**
 * Get a single booking by ID.
 */
export async function getBookingDetail(
  bookingId: string,
  apiToken: string
): Promise<BookingDetail> {
  const response = await api.get<BookingDetail>(
    `/readiness/bookings/${bookingId}`,
    authHeaders(apiToken)
  );
  return response.data;
}
